import './button-tabs.css'
import React from 'react'

type ButtonTabOption<T extends string> = {
	value: T
	label: string
	icon?: React.ComponentType<{ className?: string }>
	disabled?: boolean
}

type ButtonTabsProps<T extends string> = {
	options: ButtonTabOption<T>[]
	value: T
	onChange: (value: T) => void
	variant?: 'default' | 'compact'  // compact for icon-only
	stretch?: boolean  // flex: 1 for equal widths
	disabled?: boolean
	className?: string
	'aria-label'?: string
}

export function ButtonTabs<T extends string>({
												 options,
												 value,
												 onChange,
												 variant = 'default',
												 stretch = false,
												 disabled = false,
												 className,
												 'aria-label': ariaLabel,
											 }: ButtonTabsProps<T>) {
	return (
		<div
			className={`button-tabs ${className ?? ''}`.trim()}
			role="group"
			aria-label={ariaLabel}
		>
			{options.map((option) => {
				const isActive = value === option.value
				const isDisabled = disabled || option.disabled
				const Icon = option.icon

				return (
					<button
						key={option.value}
						onClick={() => !isDisabled && onChange(option.value)}
						disabled={isDisabled}
						aria-pressed={isActive}
						className={`button-tabs-item ${
							isActive ? 'button-tabs-item-active' : 'button-tabs-item-inactive'
						} ${stretch ? 'button-tabs-item-stretch' : ''} ${
							variant === 'compact' ? 'button-tabs-item-compact' : ''
						}`}
					>
						{Icon && <Icon className="button-tabs-icon" />}
						{variant !== 'compact' && option.label}
					</button>
				)
			})}
		</div>
	)
}
